import {useEffect, useState} from "react";
import WT from "@sscale/wtsdk";


export function useListeners() {

    const [participants, setParticipants] = useState([])

    useEffect(() => {
        WT.SessionListeners.onConnected(() => {
            WT.SessionListeners.onStreamCreated(participant => {
                if(participant.local === true)
                    setParticipants([participant]);
            });
            WT.ParticipantListeners.onParticipantLeft(({participantId}) => {
                setParticipants(prevParticipant => (
                    prevParticipant.filter((p) => p.participantId !== participantId)
                ));
            });
            WT.Participant.setMediaQuality({videoWidth: 1280, videoHeight: 720, frameRate: 11})
        });
        WT.SessionListeners.onDisconnected(() => {
            setParticipants([])
        })
    }, [])

    return participants;
}